<template>
  <div class="app-container">
    <Toast />
     <TopNavBar :isLoggedIn="isLoggedIn"/>
    <div class="app-content">
      <router-view/>
    </div>
  </div>
</template>

<style lang="scss">
.app-container {
  margin: 0 auto;
  max-width: 2400px;
  width: 100%;
  height: inherit;
  background: #F7F8F9;
  .app-content {
    margin: 8px;
  }
}
</style>
<script>
import TopNavBar from "@/components/TopNavBar";
import {useStore} from "vuex";
import {computed} from "vue";

export default {
  components: {TopNavBar},
  setup() {
    console.log("@@@@############## debbug APP.....");
    const store = useStore();
    const isLoggedIn = computed(() => {
      console.log("@@@@############## debbug APP isLoggedIn.....");
      console.log("@@@@############## debbug APP store.state.token....." + JSON.stringify(!!store.state.token));
     return  !!store.state.token;
    });

    console.log("@@@@############## debbug APP store.state. isLoggedIn....." + JSON.stringify(isLoggedIn));
    return {
      isLoggedIn
    }
  }
}
</script>
